import { WithLayoutType } from '@sbercloud/uikit-product-utils';
import { Typography } from '@snack-uikit/typography';

import { DropdownShare } from '../../helperComponents';
import styles from './styles.module.scss';

type FooterArticleProps = WithLayoutType<{
  releaseDate: string;
}>;

export function FooterArticle(props: FooterArticleProps) {
  const { layoutType, releaseDate } = props;

  const isMobile = layoutType === 'mobile';

  return (
    <div className={styles.footerArticle} data-test-id="footer-article">
      <Typography.SansBodyL className={styles.releaseDate}>
        {releaseDate}
      </Typography.SansBodyL>
      <DropdownShare hideLabel={isMobile} />
    </div>
  );
}
